import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center" data-testid="not-found-page">
      <div className="text-center px-8">
        <p className="text-[#C9A962] text-xs tracking-[0.3em] uppercase mb-6" data-testid="not-found-label">Error 404</p>
        <h1 className="text-white font-light mb-4 text-6xl"
            style={{fontFamily: "'Cormorant Garamond', serif"}}>
          Pagina no encontrada
        </h1>
        <p className="text-zinc-500 mb-10 text-lg">
          La pagina que buscas no existe o fue movida.
        </p>
        <Link
          to="/"
          data-testid="not-found-home-link"
          className="px-10 py-4 bg-[#C9A962] text-black text-xs tracking-widest uppercase font-medium hover:bg-[#DCC286] transition-colors inline-block"
        >
          Volver al inicio
        </Link>
      </div>
    </div>
  );
}
